const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text).then(() => {
    // alert("Code copied to clipboard!");
  });
};
export default copyToClipboard;
